import {MasterRange} from "@/model/entity/range/master-range"
import {EntityService} from "../entity-service"

class MasterRangeService extends EntityService<MasterRange> {
  constructor() {
    super("master_range", MasterRange)
  }
}

export interface IMasterRangeService extends EntityService<MasterRange> {
}

const service = new MasterRangeService()

export const masterRangeService = service
